<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>销售参数设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>销售参数设置</h1>
      <div class="content_wrap">
        <div class="form_wrap">
          <div class="form_item flex-rowl">
            <div class="block">
              <p><span class="mark">*</span>商品成本参考价（/件）</p>
              <div class="input_box" @click="handleShowDialog('cbprice')">
                <el-input
                  v-model="formData.cbprice"
                  type="number"
                  placeholder="请输入商品成本参考价（/件）"
                  maxlength="15"
                  readonly
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>商品基础零售价（/件）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.price"
                  type="number"
                  placeholder="请输入商品基础零售价（/件）"
                  maxlength="15"
                  :readonly="!isAllowEditPrice"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>商品批发参考价（/每件）</p>
              <div class="input_box" @click="handleShowDialog('pfprice')">
                <el-input
                  v-model="formData.pfprice"
                  type="number"
                  placeholder="请输入商品批发参考价（/每件）"
                  maxlength="10"
                  readonly
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>商品基础批发价（/每件）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.groupprice"
                  type="number"
                  placeholder="请输入商品基础批发价（/每件）"
                  maxlength="10"
                  :readonly="!isAllowEditGroupprice"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p>营销静态标价（纯静态展示用）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.salesbj"
                  type="number"
                  placeholder="请输入营销静态标价"
                  maxlength="10"
                ></el-input>
              </div>
            </div>
          </div>

          <div class="form_item flex-rowl">
            <div class="block">
              <p>商品普通用户积分兑换值（/件）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.userscore1"
                  type="number"
                  placeholder="请输入普通用户积分兑换值（/件）"
                  maxlength="15"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p>商品商务合作用户积分兑换值（/件）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.userscore2"
                  type="number"
                  placeholder="请输入商品商务合作用户积分兑换值（/件）"
                  maxlength="15"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p>商品企业积分兑换值（/件）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.userscore3"
                  type="number"
                  placeholder="请输入企业积分兑换值（/件）"
                  maxlength="15"
                ></el-input>
              </div>
            </div>
          </div>

          <div class="form_item">
            <div class="block">
              <p><span class="mark">*</span>单款混选起批数量（件/起批）</p>
              <div class="input_box">
                <el-input
                  v-model="formData.startnum1"
                  type="number"
                  placeholder="请输入商品单样单选起批数量（件/起批）"
                  maxlength="5"
                ></el-input>
              </div>
            </div>
          </div>

          <div class="form_item flex-rowl">
            <div class="block">
              <p><span class="mark">*</span>是否限购</p>
              <div class="radio_box" style="margin-bottom: 10px">
                <el-radio-group
                  v-model="formData.islimit"
                  class="flex-rowl"
                  @change="handleRadioLimit"
                >
                  <el-radio label="不限购">不限购</el-radio>
                  <el-radio label="限购">限购</el-radio>
                </el-radio-group>
              </div>
              <div class="input_box" v-if="formData.islimit == '限购'">
                <el-input
                  v-model="formData.limitnum"
                  type="digit"
                  placeholder="请输入每位用户限购数量"
                  maxlength="2"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>是否上架</p>
              <div class="radio_box">
                <el-radio-group v-model="formData.commoditystate">
                  <el-radio label="上架">上架</el-radio>
                  <el-radio label="下架">下架</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>销售状态</p>
              <div class="radio_box">
                <el-radio-group v-model="formData.salestate">
                  <el-radio label="正常销售">正常销售</el-radio>
                  <el-radio label="已售罄">已售罄</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <!-- 弹窗 start -->
    <el-dialog title="参考价" :visible.sync="isShowDialog" width="30%">
      <div class="input_box">
        <el-input
          type="number"
          v-model="priceDialog"
          placeholder="请输入商品价格"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import { getCommidityDetail, editCommidity } from "../../../api/api";
import {
  getShopConfig,
  getShopCbPrice,
  getShopTuanPrice,
} from "../../../api/shop";
export default {
  name: "cSalesParams",
  data() {
    return {
      loading: false,

      // 是否允许修改商品零售价
      isAllowEditPrice: false,
      // 是否允许修改批发参考价
      isAllowEditGroupprice: false,
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        cbprice: "", // 成本参考价
        price: "", // 零售
        pfprice: "",
        groupprice: "", // 批发价
        salesbj: "",
        userscore1: "", // 普通用户积分兑换值
        userscore2: "", // 商务合作用户积分兑换值
        userscore3: "", // 企业积分兑换值
        startnum1: "", // 单样单选起始批发购买数量
        // startnum2: "", // 混样多选起始批发购买数量
        islimit: "", // 是否限购 = 限购  不限购
        limitnum: "", // 限购数量
        commoditystate: "", // 状态 = 上架 下架
        salestate: "", // 销售状态 = 正常销售 已售罄
      },

      typeDialog: "",
      priceDialog: "", // 弹窗价格
      isShowDialog: false,
    };
  },
  created() {
    this.getDetail();
    this.getShopConfig();
  },
  methods: {
    // 权限管理
    getShopConfig() {
      getShopConfig({ columncode: "shopprice" }).then((res) => {
        res.forEach((v) => {
          if (v.evalue == "是否允许商户自行修改零售价格") {
            this.isAllowEditPrice = v.detailvalue == 0 ? false : true;
          } else if (v.evalue == "是否允许商户自行修改团购价格") {
            this.isAllowEditGroupprice = v.detailvalue == 0 ? false : true;
          }
        });
      });
    },
    // 获取商品详情
    getDetail() {
      let { id } = this.$route.params;
      this.loading = false;
      getCommidityDetail({ id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.cbprice = res.cbprice ? res.cbprice : "";
        this.formData.price = res.price ? res.price : "";
        this.formData.pfprice = res.pfprice ? res.pfprice : "";
        this.formData.groupprice = res.groupprice ? res.groupprice : "";
        this.formData.salesbj = res.salesbj ? res.salesbj : "";
        this.formData.userscore1 = res.userscore1 ? res.userscore1 : "";
        this.formData.userscore2 = res.userscore2 ? res.userscore2 : "";
        this.formData.userscore3 = res.userscore3 ? res.userscore3 : "";
        this.formData.startnum1 = res.startnum1 ? res.startnum1 : "";
        this.formData.islimit = res.islimit ? res.islimit : "不限购";
        this.formData.limitnum = res.limitnum ? res.limitnum : "";
        this.formData.commoditystate = res.commoditystate
          ? res.commoditystate
          : "下架";
        this.formData.salestate = res.salestate ? res.salestate : "正常销售";

        this.loading = false;
      });
    },
    // 获取商品成本价
    getShopCbPrice() {
      let { priceDialog } = this;
      if (priceDialog == "") {
        this.$message.warning("请输入参考价格");
        return;
      }
      getShopCbPrice({ cmprice: priceDialog }).then((res) => {
        if (res.result) {
          this.formData.cbprice = priceDialog;
          this.formData.price = res.msg;
          this.isShowDialog = false;
        }
      });
    },
    // 获取商品成本价
    getShopTuanPrice() {
      let { priceDialog } = this;
      if (priceDialog == "") {
        this.$message.warning("请输入参考价格");
        return;
      }
      getShopTuanPrice({ cmprice: priceDialog }).then((res) => {
        if (res.result) {
          this.formData.pfprice = priceDialog;
          this.formData.groupprice = res.msg;
          this.isShowDialog = false;
        }
      });
    },

    // 显示弹窗
    handleShowDialog(type) {
      this.typeDialog = type;
      this.isShowDialog = true;
    },

    handleRadioLimit(e) {
      if (e == "限购") {
        this.formData.limitnum = this.formData.limitnum
          ? this.formData.limitnum
          : 1;
      } else {
        this.formData.limitnum = "";
      }
    },

    // 确认
    handleConfirm() {
      let type = this.typeDialog;
      if (type == "cbprice") {
        this.getShopCbPrice();
      } else if (type == "pfprice") {
        this.getShopTuanPrice();
      }
    },

    query() {
      let { formData } = this;
      let params = formData;
      if (formData.cbprice == "") {
        this.$message.warning("请输入成本参考价最少2个字符");
        return;
      }
      if (formData.price == "") {
        this.$message.warning("请输入基础零售价最少2个字符");
        return;
      }
      if (formData.pfprice == "") {
        this.$message.warning("请输入商品批发参考价");
        return;
      }
      if (formData.groupprice == "") {
        this.$message.warning("请输入商品基础批发价");
        return;
      }

      if (formData.userscore1 != "") {
        if (formData.userscore1.length < 2) {
          this.$message.warning("请输入普通用户积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.userscore2 != "") {
        if (formData.userscore2.length < 2) {
          this.$message.warning("请输入商务合作用户积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.userscore3 != "") {
        if (formData.userscore3.length < 2) {
          this.$message.warning("请输入企业积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.startnum1 == "" && formData.startnum1.length < 1) {
        this.$message.warning("请输入单样单选起始批发购买数量最少2个字符");
        return;
      }
      // if (formData.startnum2 != "") {
      //   if (formData.startnum2.length < 2) {
      //     this.$message.warning("请输入混样多选起始批发购买数量最少2个字符");
      //     return;
      //   }
      // }

      this.loading = true;
      editCommidity(params).then((res) => {
        let data = res;
        if (data.result) {
          // let message = this.$message.success(data.message);
          // setTimeout(() => {
          //   this.loading = false;
          //   message.close();
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .form_wrap {
      width: 100%;
      .form_item {
        flex-wrap: wrap;
        margin-bottom: 40px;
        align-items: flex-start;
        .block {
          margin-bottom: 25px;
          width: calc(47% - 80px);
          &:nth-child(2n-1) {
            margin-right: 80px;
          }
          .radio_box {
            /deep/ .el-radio-group {
              width: 100%;
            }
          }
          .limit_content {
            flex-wrap: nowrap;
            span {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
</style>